import {
    DELETE_MEMBERSHIP_POOL,
    DELETE_MEMBERSHIP_POOL_FAILURE,
    DELETE_MEMBERSHIP_POOL_SUCCESS,
} from 'store/actions/types';

export const deleteMembershipPool = (payload) => {
    return {
        type: DELETE_MEMBERSHIP_POOL,
        payload: payload,
    };
};

export const deleteMembershipPoolFailure = (error) => {
    return {
        type: DELETE_MEMBERSHIP_POOL_FAILURE,
        error: error,
    };
};

export const deleteMembershipPoolSuccess = (payload) => {
    return {
        type: DELETE_MEMBERSHIP_POOL_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-pools/deleteMembershipPools.js